import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
try {
  if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');else require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css / index-new.css not found, proceeding without it.');
}
import { jsx, jsxs } from 'react/jsx-runtime';
import { Link } from '@design-system/link';
import classNames from 'classnames';
import { HeadingBlock } from '@design-system/heading-block';
import { Typography } from '@design-system/typography';
import React from 'react';
import { CtaBlock } from '@design-system/cta-block';
import { ExtendableImage } from '@design-system/extendable-image';
var getValidChildren = function getValidChildren(children) {
  return React.Children.toArray(children).filter(function (child) {
    return React.isValidElement(child);
  });
};
var isReactChildrenValid = function isReactChildrenValid(children) {
  return !!React.Children.count(getValidChildren(children));
};
var CardContent = function CardContent(_ref) {
  var children = _ref.children,
    headingBlock = _ref.headingBlock,
    disclaimer = _ref.disclaimer,
    category = _ref.category;
  return jsx("div", Object.assign({
    className: "cds-card__content"
  }, {
    children: jsxs("div", Object.assign({
      className: "cds-card__content-inner"
    }, {
      children: [category ? jsx(Typography, {
        className: "cds-card__category",
        content: category,
        variant: "body",
        size: "xs",
        weight: "regular",
        align: headingBlock === null || headingBlock === void 0 ? void 0 : headingBlock.align
      }) : null, jsx(HeadingBlock, Object.assign({}, headingBlock, {
        className: "cds-card__heading-block"
      })), isReactChildrenValid(children) || disclaimer ? jsxs("div", Object.assign({
        className: "cds-card__content-bottom"
      }, {
        children: [children, disclaimer && jsx(Typography, {
          className: "cds-card__disclaimer",
          variant: "body",
          size: "xs",
          tag: "p",
          content: disclaimer,
          align: headingBlock === null || headingBlock === void 0 ? void 0 : headingBlock.align
        })]
      })) : null]
    }))
  }));
};
var CardCTA = function CardCTA(_ref2) {
  var ctaBlock = _ref2.ctaBlock;
  return jsx(CtaBlock, Object.assign({}, ctaBlock, {
    className: "cds-card__cta"
  }));
};
var CardLabel = function CardLabel(_ref3) {
  var _classNames;
  var labelContent = _ref3.labelContent,
    srOnlyLabelPrefix = _ref3.srOnlyLabelPrefix,
    labelVariant = _ref3.labelVariant,
    _ref3$labelSize = _ref3.labelSize,
    labelSize = _ref3$labelSize === void 0 ? 'large' : _ref3$labelSize;
  return jsxs("div", Object.assign({
    className: classNames('cds-card__label', (_classNames = {}, _defineProperty(_classNames, "cds-card__label--".concat(labelSize), labelSize), _defineProperty(_classNames, "cds-card__label--".concat(labelVariant), labelVariant), _classNames))
  }, {
    children: [jsxs("span", Object.assign({
      className: "cds-sr-only"
    }, {
      children: [srOnlyLabelPrefix, " "]
    })), labelContent]
  }));
};
var CardMedia = function CardMedia(_ref4) {
  var image = _ref4.image,
    mediaVariant = _ref4.mediaVariant,
    children = _ref4.children;
  return jsxs("div", Object.assign({
    className: classNames('cds-card__media', _defineProperty({}, "cds-card__media--variant-".concat(mediaVariant), mediaVariant))
  }, {
    children: [children, image && jsx(ExtendableImage, Object.assign({}, image, {
      className: "cds-card__media-image"
    }))]
  }));
};
var Card = function Card(_ref5) {
  var _classNames3;
  var className = _ref5.className,
    children = _ref5.children,
    _ref5$variant = _ref5.variant,
    variant = _ref5$variant === void 0 ? 'standard' : _ref5$variant,
    link = _ref5.link,
    hasMedia = _ref5.hasMedia;
  var LinkElement = (link === null || link === void 0 ? void 0 : link.component) || Link;
  return jsxs("article", Object.assign({
    className: classNames('cds-card', (_classNames3 = {}, _defineProperty(_classNames3, "cds-card--variant-".concat(variant), variant), _defineProperty(_classNames3, "cds-card--no-media", !hasMedia), _classNames3), className)
  }, {
    children: [children, link ? jsx(LinkElement, Object.assign({}, link.props, {
      variant: "wrapper",
      className: "cds-card__link"
    })) : null]
  }));
};
Card.CardMedia = CardMedia;
Card.CardContent = CardContent;
Card.CardLabel = CardLabel;
Card.CardCTA = CardCTA;
export { Card };